import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '../Themes';

export default StyleSheet.create({
  container: {
    borderRadius: 6.2,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: Colors.red,
    marginHorizontal: 16.5,
    overflow: 'hidden',
    marginTop: 15.6,
    paddingBottom: 16.5,
    alignContent: 'flex-start',
  },
  header: {
    backgroundColor: Colors.red,
    height: 37.4,
    justifyContent: 'center',
    borderTopLeftRadius: 6.2,
    borderTopRightRadius: 6.2,
    borderWidth: 1,
    margin: 0,
    borderColor: Colors.red,
  },
  errorMessage: theme => ({
    fontSize: 20.8,
    color: theme.colors.errorMessageColor,
    marginHorizontal: 20.8,
    marginTop: 16.6,
    lineHeight: 29.1,
    marginBottom: 8.3,
    fontFamily: Fonts.type.VFFont,
  }),
  subErrorMessage: theme => ({
    fontSize: 16.6,
    color: theme.colors.subErrorMessageColor,
    marginHorizontal: 20.8,
    lineHeight: 22.9,
    fontFamily: Fonts.type.VFFont,
  }),
  warning: {
    width: 20.8,
    height: 20.8,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});
